import styled from "styled-components";

export const ShareIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  width: 100%;
`;

export const ShareLinkTextBoxContainer = styled.div`
  padding: 8px 0px;
`;

export const ShareSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0px;
`;
